var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        "before-close": _vm.close,
        "close-on-click-modal": false,
        "append-to-body": "",
        top: "7vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        open: _vm.openDialog,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dia-tit", attrs: { slot: "title" }, slot: "title" },
        [_c("i"), _c("span", [_vm._v("个人中心")])]
      ),
      _c(
        "el-form",
        {
          ref: "formData",
          attrs: { model: _vm.formData, "label-width": "100px" },
        },
        [
          _c("el-form-item", { attrs: { label: "用户名：" } }, [
            _c("span", [_vm._v(_vm._s(_vm.formData.loginName))]),
          ]),
          _c("el-form-item", { attrs: { label: "姓名：" } }, [
            _c("span", [_vm._v(_vm._s(_vm.formData.name))]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "密码：" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "info" },
                  on: { click: _vm.changePass },
                },
                [_vm._v("修改密码")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("change-pass", {
        attrs: { show: _vm.changePassDialog },
        on: {
          close: function ($event) {
            _vm.changePassDialog = false
          },
          savePass: _vm.savePass,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }